import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/** Una fila de coverage_stats (migración 128): institución en MAYÚSCULAS, tipo en minúscula. */
export interface CoverageRow {
  institution_code: string;
  tipo: string;
  total: number;
  sin_texto: number;
  year_min: number | null;
  year_max: number | null;
  years: number[];
  last_publication: string | null;
  last_ingest_at: string | null;
  computed_at: string;
}

export interface CoverageData {
  rows: CoverageRow[];
  computed_at: string | null;
}

/** GET /api/coverage (pública, sin sesión). */
export async function getCoverage(): Promise<CoverageData> {
  const response = await axios.get(`${API_URL}/coverage`);
  return response.data.data;
}
